import { render, staticRenderFns } from "./CameraPageShootCardAutoDriversLicenseFront.vue?vue&type=template&id=a7e5f34e&"
import script from "./CameraPageShootCardAutoDriversLicenseFront.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoDriversLicenseFront.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports